export default __webpack_public_path__ + "static/media/checkTeethTrue.0ce15c86.png";